<template lang="pug">
  md-card
    md-card-header(data-background-color="green")
      h4(class="title") Your Fund: {{groupData.name}}
      p(class="category") General Information for your Fund
    md-card-content(style="text-align: center;")
      md-table
        md-table-row
          md-table-cell <b>Lead Portfolio Managers</b>
          md-table-cell
            span(v-for="(name, index) in groupData.portfolio_managers") 
              span {{name}}
              span(v-if="index != groupData.portfolio_managers.length - 1") , &nbsp
        md-table-row
          md-table-cell <b>Meeting Time</b>
          md-table-cell {{groupData.day}} 
          //- @ {{groupData.hour - 12}} pm -- UNCOMMENT LATER
      //-   md-table-row
      //-     md-table-cell <b>Location</b>
      //-     md-table-cell {{groupData.location}}
      //- iframe(:src="groupData.map_url" style="border:0; height: 275px; width: 550px; margin-top: 20px;" allowfullscreen="")
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      user: null,
      groupData: null,
      error: null,
    }
  },
  props: {
    groupID: {
      type: Number,
      default: null
    }
  },
  created() {
    this.user = this.$store.state.user;
    this.getGroupInformation();
  },
  methods: {
    getGroupInformation() {
      axios.get(`/api/org/funds/${this.groupID}`)
      .then((res) => {
        this.groupData = res.data;
      }).catch((err) => {
        this.error = true;
      })
    }
  }
}
</script>

<style scoped>
  p {
    font-style: italic;
  }
</style>


// WEBPACK FOOTER //
// src/pages/Fund/FundOverview.vue